import { useAuth } from '@/features/auth/authContext'

/** Demo sessions carry no `capabilities`; these are the roles the backend grants `LEAD_CREATE`. */
const LEAD_CREATE_ROLES: ReadonlySet<string> = new Set([
  'branch_staff',
  'branch_manager',
  'franchise_partner',
])

/**
 * The Website-Formular page needs `LEAD_CREATE`, the guard of `GET /api/website-intake` itself,
 * so whoever sees the entry can also load the page.
 */
export function canViewWebsiteForm(
  capabilities: readonly string[] | undefined,
  roleKey: string | undefined,
): boolean {
  if (capabilities) return capabilities.includes('LEAD_CREATE')
  return roleKey !== undefined && LEAD_CREATE_ROLES.has(roleKey)
}

export function useCanViewWebsiteForm(): boolean {
  const { session, role } = useAuth()
  return canViewWebsiteForm(session?.capabilities, role?.key)
}
